import React from 'react';
export function PlayCircleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm0 18a8 8 0 118-8 8.009 8.009 0 01-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6 8.2A1 1 0 0010 9v6a1 1 0 001.6.8l4-3a.999.999 0 000-1.6l-4-3z"
  }));
}